import { render, staticRenderFns } from "./TableHeaders.vue?vue&type=template&id=08fda142&scoped=true&"
import script from "./TableHeaders.vue?vue&type=script&lang=js&"
export * from "./TableHeaders.vue?vue&type=script&lang=js&"
import style0 from "./TableHeaders.vue?vue&type=style&index=0&id=08fda142&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fda142",
  null
  
)

export default component.exports